'use client';

import { DeprecatedPopover } from '@lmn/design-system';
import { IconCircleInformation } from '@/app/common/icons/libraryIcons';
import React, { type JSX } from 'react';
import { useTranslation } from '@/app/components/translations/Translation';

const SortPopover = ({ rankingTooltip }: { rankingTooltip: JSX.Element }) => {
  const { t } = useTranslation();
  return (
    <>
      {t('vacation.oss.components.searchresults.sort.recommended')}
      <DeprecatedPopover zIndex={9999} content={rankingTooltip}>
        <span>
          <IconCircleInformation size={16} />
        </span>
      </DeprecatedPopover>
    </>
  );
};

export default SortPopover;
